










































import Vue from 'vue'
import Nav from '@/components/Nav.vue'
import InvoiceForm from '@/components/InvoiceForm.vue'
import { Invoice } from '@/interfaces'

export default Vue.extend({
  components: { Nav, InvoiceForm },
  props: {
    invoice: {
      type: Object as () => Invoice,
      required: false,
      default: () => {
        return {
          id: null,
        }
      },
    },
  },
  data() {
    return {
      displayAlert: false,
      invoiceId: '',
      invoiceData: {
        parentInvoiceId: null as number | null,
        parentInvoiceType: null as string | null,
        parentInvoiceNumber: null as string | null,
      } as Invoice,
      triggerSave: false,
    }
  },
  mounted() {
    this.invoiceId = this.$route.params.id
    this.displayAlert = false
  },
  methods: {
    goBack() {
      this.triggerSave = !this.triggerSave
      if (this.$route.query.backTo) {
        const backTo = this.$route.query.backTo.toString()
        const backScrollTo = this.$route.query.backScrollTo?.toString() ?? '0'
        const backSaleId = this.$route.query.backSaleId?.toString()
        const backInventoryId = this.$route.query.backInventoryId?.toString()
        const query = { ...this.$route.query, scrollTo: backScrollTo } as Record<string, any>

        delete query.backTo
        delete query.backScrollTo
        delete query.backSaleId
        delete query.backInventoryId

        this.$router.push({
          name: backTo,
          params: backInventoryId ? { inventoryId: backInventoryId } : backSaleId ? { saleId: backSaleId } : {},
          query,
        })
        return
      }

      this.$router.back()
    },
    updateInvoiceData(invoice: Invoice) {
      this.invoiceData = invoice
    },
    getParentInvoiceInfo() {
      let type = ''
      if (this.invoiceData?.parentInvoiceType === 'bordereau') {
        type += 'Bordereau'
      } else if (this.invoiceData.parentInvoiceType === 'decompte') {
        type += 'Décompte'
      } else {
        type += 'Facture'
      }

      return type + ' ' + (this.invoiceData.parentInvoiceNumber ?? '')
    },
  },
})
